<template>
  <a-modal width="50%" :label-col="4" :wrapper-col="14" :visible="visible" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>修改商品分类</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item :label="$t('商品.商品分类')" prop="categoryId">
        <template>
          <a-cascader :options="categoryList"
                      :field-names="{ label: 'categoryName', value: 'id', children: 'children'}"
                      :placeholder="$t('通用.输入.请输入')+$t('商品.商品分类')"
                      style="width: 100%" v-model="categorySelected" allowClear @change="onCategoryChange">
          </a-cascader>
        </template>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('通用.按钮.确定')}}
          </a-button>
          <a-button type="dashed" @click="onClose">
            {{$t('通用.按钮.取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-modal>
</template>

<script>
import {updateGoodsType} from "@/api/goods/goods";
import {listCategory} from "@/api/goods/category";

export default {
  name: 'ModifyAddress',
  data () {
    return {
      /*分类的回显*/
      ids:[],
      categorySelected: [],
      addrList: [],
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      categoryList: [{id: "0", categoryName: '', children: []}],
      submitLoading: false,
      loading: '',
      // 表单参数
      form: {
        id: null,
        categoryId:[]
      },
      visible: false,
      rules: {
        categoryId: [{
          required: true,
          message: this.$t('商品.商品分类') + this.$t('通用.文本.不能为空'),
          trigger: 'blur'
        }],
      }
    }
  },
  methods: {
    open(row){
        this.visible = true
        this.ids = row
        this.getCategoryList()

    },

    /*分类的选择*/
    onCategoryChange(value, selectedOptions) {
      if (value[1]) {
        this.form.categoryId = value[1]
      } else {
        this.form.categoryId = value[0]
      }
    },



    //商品类别
    getCategoryList(){
        listCategory().then(response => {
            let children = this.handleTree(response.data, 'id', 'pid')
            console.log('children', children)
            this.categoryList = children
        })
    },
    // 取消按钮
    onClose () {
      
      this.visible = false
      this.reset()
    },
    // 表单重置
    reset () {
     
      this.form = {
        id: null,
        categoryId:null
      }
      this.categorySelected = []

    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          console.log(this.form,this.ids);
          let params = {
            idList:this.ids,
            categoryId:this.form.categoryId
          }
          updateGoodsType(params).then(res=>{
            if(res.success){
              this.visible = false
              this.$message.success('修改成功')
              this.$emit('setUpdate')
            }
            

          })
          
          // this.submitLoading = true
          // let message= this.$t('售后订单.审核成功')
          // auditRefund(this.form).then(response => {
          //   this.$message.success(
          //     message,
          //     3
          //   )
          //   this.visible = false
          //   this.$emit('ok')
          // }).finally(() => {
          //   this.submitLoading = false
          // })
        } else {
          return false
        }
      });
    }
  }
}
</script>
<style  lang="less" scoped>
.info-table {
  tr {
    height: 50px;
  }
  td {
    display: table-cell;
    vertical-align: top;
    font-size: 16px;
  }
  .first {
    width: 120px;
  }
  .data {
    width: 280px;
  }
}
</style>
